import { useEffect, useState } from 'react';
import { noRespPendingHeader } from './data'
import { TablePagination, IconButton } from '@mui/material';
import API from 'Api';
// import * as XLSX from "xlsx";
import XLSX from "xlsx-js-style";
import exportIcon from '../../assets/icons/export.svg';
import NoRecordFound from './noRecordFound';
import { dateConvertToUSTime, formatPhoneNumber, formatToMMDDYYYY } from "components/helper/helper";
import { logDOM } from '@testing-library/react';
import Loader from 'react-loader-spinner';
import ruleoutLogo from '../../assets/icons/logo2.svg';
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

const NoResponseDataTable = ({ filterType, showLoader }) => {
    let rowCount = 1000;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(rowCount);
    const [denialList, setDenialList] = useState([])
    const [pendingList, setPendingList] = useState([])
    const [completedList, setCompletedList] = useState([])
    const [totalRecord, setTotalRecord] = useState(0)
    const [showLoaderOnCountChange, setShowLoaderOnCountChange] = useState(false);
    const [showCancelLoader, setShowCancelLoader] = useState(false);

    let practice = JSON.parse(sessionStorage.getItem("practice"))?.id

    const getData = async ({ filterType = null, limit = rowsPerPage, pgPage = page }) => {
        setShowLoaderOnCountChange(true);
        let chargesTimer = setTimeout(() => setShowCancelLoader(!showCancelLoader), 15000)
        if (filterType === 'completed') {
            let result = await API.get(`/getnoRespCompletedList?page=${pgPage}&limit=${limit}`)
            clearTimeout(chargesTimer);
            setShowLoaderOnCountChange(false);
            if (result.data.success === true) {
                setDenialList(result.data.data)
                setTotalRecord(result.data.pagination.totalRecords)
                setCompletedList(result.data.data)
            }
            setShowCancelLoader(false)
        } else {
            let result = await API.get(`/getPendingValidationInNR?page=${pgPage}&limit=${limit}`)
            clearTimeout(chargesTimer);
            setShowLoaderOnCountChange(false);
            if (result.data.success === true) {
                setDenialList(result.data.data)
                setTotalRecord(result.data.pagination.totalRecords)
                setPendingList(result.data.data)
            }
            setShowCancelLoader(false)
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        getData({ pgPage: newPage, filterType })
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        let limit = parseInt(event.target.value)
        setRowsPerPage(limit);
        getData({ limit, pgPage: 0, filterType })
    };

    const resetStates = () => {
        setDenialList([])
        setTotalRecord(0)
        setPage(0)
    }

    useEffect(() => {
        if (filterType === 'pendingWorkedValidation') {
            getData({ limit: rowsPerPage })
        } else if (filterType === 'completed') {
            resetStates();
            getData({ filterType, limit: rowsPerPage })
        }
    }, [filterType, practice])

    // function to export pending and completed list
    // const exportNoRespPendingOrCompleted = () => {
    //     let practice = JSON.parse(sessionStorage.getItem("practice"))
    //     // const exportedExcelName = practice == "all" ? `All Practices` : practice?.practiceName;
    //     let exportedExcelName;
    //     if (filterType == "completed") {
    //         if (practice == "all") {
    //             exportedExcelName = "All Practices-No Response-Completed";
    //         } else {
    //             exportedExcelName = `${practice?.practiceAcronym}-No Response-Completed`;
    //         }
    //     } else {
    //         if (practice == "all") {
    //             exportedExcelName = "All Practices-No Response-Pending Worked Validation";
    //         } else {
    //             exportedExcelName = `${practice?.practiceAcronym}-No Response-Pending Worked Validation`;
    //         }
    //     }
    //     let noRespPendingOrCompleted = filterType === "completed" ? completedList : pendingList;
    //     let exportedNoRespData = [];


    //     noRespPendingOrCompleted.map(item => {
    //         const newItem = {};
    //         newItem["PracticeName"] = item.PracticeName;
    //         newItem["CustomerID"] = Number(item.CUSTOMERID);
    //         newItem["ClaimID"] = Number(item.CLAIMID);
    //         newItem["EncounterID"] = Number(item.EncounterID);
    //         newItem["PatientID"] = Number(item.PATIENTID);
    //         newItem["PatientName"] = item.PatientName;
    //         newItem["DOB"] = formatToMMDDYYYY(item.DOB);
    //         newItem["ServiceStartDate"] = formatToMMDDYYYY(item.ServiceStartDate);
    //         newItem["RenderingProviderID"] = Number(item.RENDERING_PROVIDER_ID);
    //         newItem["RenderingProviderName"] = item.RENDERING_PROVIDER_NAME;
    //         newItem["SchedulingProviderID"] = Number(item.SCHEDULING_PROVIDER_ID);
    //         newItem["SchedulingProviderName"] = item.SchedulingProviderName;
    //         newItem["ServiceLocationName"] = item.Facility;
    //         newItem["InsPhone"] = formatPhoneNumber(item.InsPhone);
    //         newItem["PolicyNumber"] = item.PolicyNumber;
    //         newItem["BilledTo"] = item.Billed_to;
    //         newItem["InsPlanID"] = Number(item.InsPlanID);
    //         newItem["Code"] = item.Code;
    //         newItem["TotalCharge"] = Number(item.Total_Charge);
    //         newItem["Balance"] = Number(item.Balance);
    //         newItem["Status"] = filterType == "workList" ? "Worklist" : filterType == "completed" ? "Completed" : "Pending Worked Validation";
    //         // newItem["Status"] = item.status == null ? "Worklist" : (item.ActionTaken == "Remove" || item.ActionTaken == "Unknown") ? "Completed" : "Pending Worked Validation";
    //         newItem["Repeat"] = item.Repeat == false || item.Repeat == null ? "No" : "Yes";
    //         newItem["AssignedTo"] = item.AssignedTo;
    //         newItem["WhatsNeeded"] = item.WhatsNeeded;
    //         newItem["NoRespDate"] = formatToMMDDYYYY(item.NoRespDate);
    //         newItem["DueDate"] = formatToMMDDYYYY(item.DueDate);
    //         newItem["ActionTaken"] = item.ActionTaken;
    //         newItem["WorkedBy"] = item.WorkedBy;
    //         newItem["DateCompleted"] = new Date(item.DateWorked).toLocaleDateString('en-US', {month: "2-digit", day: "2-digit", year: "numeric"});
    //         newItem["LastNote"] = item.Notes[0] != undefined ? item.Notes[0].NOTES : "";
    //         newItem["CreatedOn"] = item.created_at;
    //         newItem["UpdatedOn"] = item.updated_at;
    //         exportedNoRespData.push(newItem);
    //     })
    //     const worksheet = XLSX.utils.json_to_sheet(exportedNoRespData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "No Response Data");
    //     XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`);
    // }


    // const exportNoRespPendingOrCompleted = () => {
    //     let practice = JSON.parse(sessionStorage.getItem("practice"));
    //     let exportedExcelName;
    //     if (filterType == "completed") {
    //         if (practice == "all") {
    //             exportedExcelName = "All Practices-No Response-Completed";
    //         } else {
    //             exportedExcelName = `${practice?.practiceAcronym}-No Response-Completed`;
    //         }
    //     } else {
    //         if (practice == "all") {
    //             exportedExcelName = "All Practices-No Response-Pending Worked Validation";
    //         } else {
    //             exportedExcelName = `${practice?.practiceAcronym}-No Response-Pending Worked Validation`;
    //         }
    //     }
    //     let noRespPendingOrCompleted = filterType === "completed" ? completedList : pendingList;

    //     const toExcelDateMidnightUTC = (formattedDate) => {
    //         console.log(formattedDate)
    //         let value;
    //         if (/^\d{2}\/\d{2}\/\d{4}$/.test(formattedDate)) {
    //             value = formattedDate;
    //         } else {
    //             value = formatToMMDDYYYY(formattedDate)
    //         }
    //         if (!value) return null; // keep empty if null/undefined
    //         const d = new Date(value);
    //         const utcDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    //         const epoch = new Date(Date.UTC(1899, 11, 30));
    //         return (utcDate - epoch) / (24 * 60 * 60 * 1000);
    //     };

    //     let exportedNoRespData = noRespPendingOrCompleted.map(item => ({
    //         PracticeName: item.PracticeName,
    //         CustomerID: Number(item.CUSTOMERID),
    //         ClaimID: Number(item.CLAIMID),
    //         EncounterID: Number(item.EncounterID),
    //         PatientID: Number(item.PATIENTID),
    //         PatientName: item.PatientName,
    //         DOB: toExcelDateMidnightUTC(item.DOB),
    //         ServiceStartDate: toExcelDateMidnightUTC(item.ServiceStartDate),
    //         RenderingProviderID: Number(item.RENDERING_PROVIDER_ID),
    //         RenderingProviderName: item.RENDERING_PROVIDER_NAME,
    //         SchedulingProviderID: Number(item.SCHEDULING_PROVIDER_ID),
    //         SchedulingProviderName: item.SchedulingProviderName,
    //         ServiceLocationName: item.Facility,
    //         InsPhone: formatPhoneNumber(item.InsPhone),
    //         PolicyNumber: item.PolicyNumber,
    //         BilledTo: item.Billed_to,
    //         InsPlanID: Number(item.InsPlanID),
    //         Code: item.Code,
    //         TotalCharge: Number(item.Total_Charge ?? 0),
    //         Balance: Number(item.Balance),
    //         Status:
    //             filterType === "workList"
    //                 ? "Worklist"
    //                 : filterType === "completed"
    //                     ? "Completed"
    //                     : "Pending Worked Validation",
    //         Repeat: item.Repeat ? "Yes" : "No",
    //         AssignedTo: item.userName,
    //         WhatsNeeded: item.WhatsNeeded == null && item.url != null ? "Pull From Portal" : item.WhatsNeeded,
    //         NoRespDate: toExcelDateMidnightUTC(item.NoRespDate),
    //         DueDate: toExcelDateMidnightUTC(item.DueDate),
    //         ActionTaken: item.ActionTaken,
    //         WorkedBy: item.WorkedBy,
    //         DateWorked: toExcelDateMidnightUTC(item.DateWorked),
    //         LastNote: item.Notes?.[0]?.NOTES || "",
    //         CreatedOn: toExcelDateMidnightUTC(item.created_at),
    //         UpdatedOn: toExcelDateMidnightUTC(item.updated_at)
    //     }));

    //     const worksheet = XLSX.utils.json_to_sheet(exportedNoRespData);

    //     // Apply proper styles for number and date columns

    //     Object.keys(worksheet).forEach(cell => {
    //         if (cell[0] === '!') return;

    //         // Number columns (integers)

    //         if (["B", "C", "D", "E", "I", "K", "Q", "S", "T"].includes(cell.replace(/[0-9]/g, ''))) {
    //             worksheet[cell].t = 'n';
    //             worksheet[cell].s = { numFmt: "0" };
    //         }

    //         // Decimal columns

    //         if (["TotalCharge", "Balance"].includes(worksheet[cell]?.v)) {
    //             worksheet[cell].t = 'n';
    //             worksheet[cell].s = { numFmt: "0.00" };
    //         }

    //         // Date columns

    //         if (["G", "H", "Y", "Z", "AE", "AF"].includes(cell.replace(/[0-9]/g, ''))) {
    //             if (worksheet[cell].v != null) {
    //                 worksheet[cell].t = 'n';
    //                 worksheet[cell].s = { numFmt: 14 }; // Built-in Excel Short Date
    //             }
    //         }
    //     });

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "No Response Data");
    //     XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`);
    // }



    // -------------------------- Excel Testing -------------------------- //

    const exportNoRespPendingOrCompleted = () => {
        let practice = JSON.parse(sessionStorage.getItem("practice"));
        let exportedExcelName;
        if (filterType == "completed") {
            if (practice == "all") {
                exportedExcelName = "All Practices-No Response-Completed";
            } else {
                exportedExcelName = `${practice?.practiceAcronym}-No Response-Completed`;
            }
        } else {
            if (practice == "all") {
                exportedExcelName = "All Practices-No Response-Pending Worked Validation";
            } else {
                exportedExcelName = `${practice?.practiceAcronym}-No Response-Pending Worked Validation`;
            }
        }
        let noRespPendingOrCompleted = filterType === "completed" ? completedList : pendingList;

        // const toExcelDateMidnightUTC = (formattedDate) => {
        //     let value;
        //     if (/^\d{2}\/\d{2}\/\d{4}$/.test(formattedDate)) {
        //         value = formattedDate;
        //     } else {
        //         value = formatToMMDDYYYY(formattedDate);
        //     }
        //     if (!value) return null;
        //     const d = new Date(value);
        //     const utcDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        //     const epoch = new Date(Date.UTC(1899, 11, 30));
        //     return (utcDate - epoch) / (24 * 60 * 60 * 1000);
        // };

        // const toExcelDateMidnightUTC = (formattedDate) => {
        //     if (!formattedDate) return null;

        //     let date;
        //     // Check if the date string contains time information (indicated by 'T')
        //     if (formattedDate.includes('T')) {
        //         // For dates with time, create a Date object directly.
        //         // It will be parsed correctly with the timezone information.
        //         date = new Date(formattedDate);
        //     } else {
        //         // For date-only strings (like "2025-09-21"), construct it manually
        //         // to ensure it is treated as local midnight, not UTC midnight.
        //         const [year, month, day] = formattedDate.split('-').map(Number);
        //         date = new Date(year, month - 1, day); // month is 0-indexed
        //     }
        //     // Handle invalid dates
        //     if (isNaN(date.getTime())) {
        //         console.error('Invalid date received:', formattedDate);
        //         return null;
        //     }
        //     // Calculate the Excel date number based on the Excel epoch
        //     const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        //     return (date.getTime() - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
        // };

        const toExcelDateMidnightUTC = (formattedDate) => {
            if (!formattedDate) return null;

            let date;

            // Check if the date string includes time information (indicated by 'T' or a space)
            if (formattedDate.includes('T') || formattedDate.includes(' ')) {
                // If a time component exists, create a Date object and then zero out the time.
                date = new Date(formattedDate);
                if (isNaN(date.getTime())) {
                    console.error('Invalid date received:', formattedDate);
                    return null;
                }
                // Zero out the time components to get the start of the day in local time
                date.setHours(0, 0, 0, 0);

            } else {
                // For date-only strings (like "2025-09-21"), construct it manually
                // to ensure it is treated as local midnight, not UTC midnight.
                const [year, month, day] = formattedDate.split('-').map(Number);
                date = new Date(year, month - 1, day); // month is 0-indexed
            }

            // Handle invalid dates
            if (isNaN(date.getTime())) {
                console.error('Invalid date received:', formattedDate);
                return null;
            }

            // Create a new date at UTC midnight to perform the Excel number calculation
            // This is the most reliable way to prevent timezone shifts
            const utcMidnightMillis = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

            // Calculate the Excel date number based on the Excel epoch
            const excelEpoch = new Date(Date.UTC(1899, 11, 30));
            return (utcMidnightMillis - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
        };


        const exportColumns = [
            { key: "PracticeName" },
            { key: "CustomerID", type: "integer" },
            { key: "ClaimID", type: "integer" },
            { key: "EncounterID", type: "integer" },
            { key: "PatientID", type: "integer" },
            { key: "PatientName" },
            { key: "DOB", type: "date" },
            { key: "ServiceStartDate", type: "date" },
            { key: "RenderingProviderID", type: "integer" },
            { key: "RenderingProviderName" },
            { key: "SchedulingProviderID", type: "integer" },
            { key: "SchedulingProviderName" },
            { key: "ServiceLocationName" },
            { key: "InsPhone", type: "text" },
            { key: "PolicyNumber" },
            { key: "BilledTo" },
            { key: "InsPlanID", type: "integer" },
            { key: "Code" },
            { key: "TotalCharge", type: "decimal" },
            { key: "Balance", type: "decimal" },
            { key: "Status" },
            { key: "Repeat" },
            { key: "AssignedTo" },
            { key: "WhatsNeeded" },
            { key: "NoRespDate", type: "date" },
            { key: "DueDate", type: "date" },
            { key: "ActionTaken" },
            { key: "WorkedBy" },
            { key: "DateWorked", type: "date" },
            { key: "LastNote" },
            { key: "CreatedOn", type: "date" },
            { key: "UpdatedOn", type: "date" }
        ];

        // Sanitize data into array of objects
        const sanitizedData = noRespPendingOrCompleted.map(item => ({
            PracticeName: item.PracticeName,
            CustomerID: Number(item.CUSTOMERID),
            ClaimID: Number(item.CLAIMID),
            EncounterID: Number(item.EncounterID),
            PatientID: Number(item.PATIENTID),
            PatientName: item.PatientName,
            DOB: toExcelDateMidnightUTC(item.DOB),
            ServiceStartDate: toExcelDateMidnightUTC(item.ServiceStartDate),
            RenderingProviderID: Number(item.RENDERING_PROVIDER_ID),
            RenderingProviderName: item.RENDERING_PROVIDER_NAME,
            SchedulingProviderID: Number(item.SCHEDULING_PROVIDER_ID),
            SchedulingProviderName: item.SchedulingProviderName,
            ServiceLocationName: item.Facility,
            InsPhone: item.InsPhone,
            PolicyNumber: item.PolicyNumber,
            BilledTo: item.Billed_to,
            InsPlanID: Number(item.InsPlanID),
            Code: item.Code,
            TotalCharge: Number(item.Total_Charge ?? 0),
            Balance: Number(item.Balance),
            Status:
                filterType === "workList"
                    ? "Worklist"
                    : filterType === "completed"
                        ? "Completed"
                        : "Pending Worked Validation",
            Repeat: item.Repeat ? "Yes" : "No",
            AssignedTo: item.userName,
            WhatsNeeded:
                item.WhatsNeeded == null && item.url != null
                    ? "Pull From Portal"
                    : item.WhatsNeeded,
            NoRespDate: toExcelDateMidnightUTC(item.NoRespDate),
            DueDate: toExcelDateMidnightUTC(item.DueDate),
            ActionTaken: item.ActionTaken,
            WorkedBy: item.WorkedBy,
            DateWorked: toExcelDateMidnightUTC(item.DateWorked),
            LastNote: item.Notes?.NOTES || "",
            CreatedOn: toExcelDateMidnightUTC(item.created_at),
            UpdatedOn: toExcelDateMidnightUTC(item.updated_at)
        }));

        // Convert to array of arrays (values only, no headers)
        const dataOnly = sanitizedData.map(item =>
            exportColumns.map(col => item[col.key])
        );

        // Create a new empty worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // 1. Add the header row starting at A1
        XLSX.utils.sheet_add_aoa(worksheet, [exportColumns.map(col => col.key)], { origin: "A1" });

        // 2. Add the data starting from A2 (after the header)
        XLSX.utils.sheet_add_aoa(worksheet, dataOnly, { origin: "A2" });

        // const worksheet = XLSX.utils.aoa_to_sheet(dataOnly);
        // XLSX.utils.sheet_add_aoa(
        //     worksheet,
        //     [exportColumns.map(col => col.key)], // build header row from exportColumns
        //     { origin: "A1" }
        // );

        // Apply styles
        exportColumns.forEach((col, colIndex) => {
            const colLetter = XLSX.utils.encode_col(colIndex);
            for (let rowIndex = 1; rowIndex <= sanitizedData.length + 1; rowIndex++) {
                const cellAddress = `${colLetter}${rowIndex}`;
                const cell = worksheet[cellAddress];
                if (cell) {
                    if (col.type === "integer") {
                        cell.s = { numFmt: "0" };
                    } else if (col.type === "decimal") {
                        cell.s = { numFmt: "0.00" };
                    } else if (col.type === "date") {
                        cell.s = { numFmt: "mm/dd/yyyy" };
                    }
                }
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "No Response Worklist");
        XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`, {
            Props: { Title: exportedExcelName }
        });
    };



    // -------------------------- Excel Testing End ---------------------- //



    const styles = {
        content: {
            width: '100%',
            marginTop: '0rem',
            // padding: '0rem 0rem 1rem 1.5rem',
            // border: '0px !important',
            // position: 'absolute'
        }
    }

    const getColour = (actionName) => {
        let colour = ''
        switch (actionName) {
            case 'Obtained EOB via Fax':
            case 'Obtained EOB via Phone':
            case 'Obtained EOB via Portal':
            case 'Fax':
            case 'Phone':
            case 'Portal':
            case 'Fixed Posting Error':
                colour = '#5CB02C'
                break
            case 'Appealed':
            case 'Rebilled':
            case 'Ins Transfer':
                colour = '#C88700'
                break
            case 'Patient Billed':
                colour = '#0097FA'
                break
            case 'Settled':
            case 'Voided':
                colour = '#EB0000'
                break
            case 'Remove':
            case 'Unknown':
                colour = '#535353'
                break
            default:
                break
        }
        return colour
    }

    return <div style={styles.content}>
        <div className={`1pt-4 table-responsive custom-size tableresponsivecustom noresponse-table pending-table denial-style w-100 }`}>
            { } <table className="denial-table">
                <thead>
                    <tr>
                        {noRespPendingHeader.map((col, index) => (
                            <th className='text-center' key={index} >
                                <span>{col.name}</span>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {!denialList?.length && !showLoader ? <NoRecordFound /> : denialList?.length > 0 && denialList?.map((data, idx) => (

                        <tr style={{ cursor: 'pointer' }} key={idx} className='table-row'>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.CLAIMID}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.EncounterID}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.PatientName} className='deal-content'>{data.PatientName}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{dateConvertToUSTime(data.ServiceStartDate)}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.SchedulingProviderName} className='deal-content'>{data.SchedulingProviderName}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.Facility} className='deal-content'>{data.Facility}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.Billed_to} className='deal-content'>{data.Billed_to}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Code}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Total_Charge}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Balance}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.Repeat == null || false ? "No" : "Yes"}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.WhatsNeeded} className='one-line-ellipsis'>{data.WhatsNeeded}</span>
                                </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.WorkedBy}</div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.NoRespDate} className='one-line-ellipsis'>{dateConvertToUSTime(data.NoRespDate)}</span>
                                </div>
                            </td>
                            {/* <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>
                                    <span title={data.DueDate} className='one-line-ellipsis'>{data.DueDate}</span>
                                </div>
                            </td> */}
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata'>{data.DateWorked != null ? dateConvertToUSTime(data.DateWorked) : ""}</div>
                                {/* <div className='innerdata'>{data.DateWorked != null ? new Date(data.DateWorked).toLocaleDateString('en-US', {
                                    month: "2-digit", day: "2-digit", year: "numeric"
                                }) : ""}</div> */}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                                <div className='innerdata' >
                                    <span style={{ backgroundColor: getColour(data.ActionTaken), color: '#fff', lineHeight: 'normal', padding: "4px 10px", borderRadius: '25px', width: '125px' }}>
                                        {data.ActionTaken == "Fax" ? "Obtained EOB via Fax" : data.ActionTaken == "Phone" ? "Obtained EOB via Phone" : data.ActionTaken == "Portal" ? "Obtained EOB via Portal" : data.ActionTaken}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className='rule-footer'>
                <div className='foot-flex'>
                    <div >
                        <div>
                            <span className="text-dark font-face-futura">
                                <span className='fontw'>Total Encounters: <span className='fw-normal'>{totalRecord}</span></span>
                            </span>
                            <IconButton className='export-container'>
                                <div className='export-btn'>
                                    <input
                                        type="image"
                                        src={exportIcon}
                                        alt="exportDenial"
                                        className="mx-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => exportNoRespPendingOrCompleted()}
                                    />
                                    <span className='export'>Export</span>
                                </div>
                            </IconButton>
                        </div>
                    </div>
                    <div>
                        <TablePagination
                            component="p"
                            count={totalRecord}
                            page={page}
                            rowsPerPageOptions={[rowCount, 2000, 4000]}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            className='pendingtable-pagination'
                        />
                    </div>
                </div>
            </div>
        </div>
        {
            showLoaderOnCountChange &&
            <Dialog
                fullWidth
                open={showLoaderOnCountChange}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <div align="center" className={showCancelLoader ? 'avatar2' : 'avatar'}>
                    <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                    <Loader className="mt-2" type='Oval'
                        height={180}
                        width={195}
                        color="#5CB02C"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#5CB02C"
                        strokeWidth={2}
                        strokeWidthSecondary={2} />
                </div>
                <div align="center" className={showCancelLoader ? 'dialog-box2' : 'dialog-box'}>
                    <DialogTitle id="alert-dialog-title">
                        <span className='font-face-futura dialogTitle'>{"Updating No Response"}</span>
                    </DialogTitle>
                    {showCancelLoader ?
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <span className='dialogText'>Hold tight while we fetch a new list of No Responses!</span>
                            </DialogContentText><br />
                            <DialogContentText id="alert-dialog-description">
                                <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                <span className='dialogText'>Give us a little bit longer</span>
                            </DialogContentText>
                            <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                <span className='font-face-futura'>Cancel</span>
                            </Button>
                        </DialogContent> :
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <span className='font-face-futura dialogText'>Let's get you a new list of No Responses!</span>
                            </DialogContentText>
                        </DialogContent>}
                </div>
            </Dialog>
        }
    </div>
}

export {
    NoResponseDataTable
}